module.exports = __webpack_public_path__ + "img/notes-outlined-red.66fc050f.svg";